const getModal = (state) => state.modal;

export const getIsModalOpen = (state) => getModal(state).isOpen;
export const getModalName = (state) => getModal(state).name;
